import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/** The sheet's back affordance: a body row naming where it lands. */
@Component({
  selector: 'app-play-back-row',
  template: `
    <button type="button" class="backrow" (click)="back.emit()">
      <span class="cv">‹</span><span class="dest">Back to {{ dest() }}</span>
    </button>
  `,
  styleUrl: './play-back-row.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayBackRowComponent {
  readonly dest = input.required<string>();
  readonly back = output<void>();
}
